import { App } from "vue"

import LeftMenu from './leftMenu'
import WrapContainer from './WrapContainer'

const components = [LeftMenu,WrapContainer]

export default {
    install(app:App){
        components.map(item=>{
            app.use(item)
        })
    }
}